module.exports = __webpack_public_path__ + "img/registration-icon.54e40f58.svg";